import styled from 'styled-components/macro';
import { ReactComponent as ChevronRight } from '../images/icons/chevron-right.svg';
import { Link } from '../shared/Link';
import { colourNeutral11, colourPurple02 } from '../styling/colours';
import { spacing03, spacing04, spacing05 } from '../styling/spacing';

export const BreadcrumbBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${spacing04} ${spacing05};
  background-color: ${colourPurple02};
  color: ${colourNeutral11};
`;

export const BreadcrumbSeparator = styled(ChevronRight)`
  height: 20px;
  margin: 0 ${spacing03};
  position: relative;
  top: 2px;
  color: white;
  opacity: 0.75;
`;

export const BreadcrumbLink = styled(Link)`
  color: white;
  opacity: 0.75;

  &:hover {
    opacity: 1;
  }
`;
